import { useGetAffectationCountQuery } from '@/features/api/endpoints/affectationEndpoints';
import { useGetCurrentUser } from '@/shared/auth/useDirectusUser';
import { Badge, Menu } from '@mantine/core';
import { IconUserCheck } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';

const AffectationsMenuItem = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const { user } = useGetCurrentUser();

  const { data: publishedCount } = useGetAffectationCountQuery(
    {
      filter: {
        user: { _eq: user?.id },
        status: { _eq: 'published' },
      },
    },
    { skip: !user?.id },
  );

  const { data: draftCount } = useGetAffectationCountQuery(
    {
      filter: {
        user: { _eq: user?.id },
        status: { _eq: 'draft' },
      },
    },
    { skip: !user?.id },
  );

  return (
    <Menu.Item
      leftSection={<IconUserCheck stroke={1.5} />}
      rightSection={
        <>
          {publishedCount != null && publishedCount > 0 ? (
            <Badge size="xs" variant="filled" circle color="green">
              {publishedCount}
            </Badge>
          ) : undefined}
          {draftCount != null && draftCount > 0 ? (
            <Badge size="xs" variant="filled" circle color="yellow" ml={5}>
              {draftCount}
            </Badge>
          ) : undefined}
        </>
      }
      onClick={() => navigate('/profil/affectations')}
    >
      {t('nav.profil.affectations')}
    </Menu.Item>
  );
};

export default AffectationsMenuItem;
